import { render } from "./Kpi.vue?vue&type=template&id=087f75f5&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"

import "./Kpi.vue?vue&type=style&index=0&id=087f75f5&lang=scss&scoped=true"

import exportComponent from "/home/irevors/CODING/ESTUDIOS/SENCE/ensayo prueba TD/ensayo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087f75f5"]])

export default __exports__